module.exports = __webpack_public_path__ + "static/img/9.70b736b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/brand/9.png
// module id = QJec
// module chunks = 45